/**
 * @file Re-exports the InvestmentProfileUpdateDrawer component.
 */
import InvestmentProfileUpdateDrawer from "./InvestmentProfileUpdateDrawer";

export default InvestmentProfileUpdateDrawer;
